import {Component, Inject} from '@angular/core';
import {MD_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent {

  message: string;
  type: string;

  /**
   * Initialize variables with the modal config
   * @param data
   */
  constructor(@Inject(MD_DIALOG_DATA) public data: any) {
    this.message = data.message;
    if (data.type) {
      this.type = data.type;
    } else {
      this.type = 'success';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modals/success/success.component.ts